import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { faHomeHeart } from '@fortawesome/pro-regular-svg-icons/faHomeHeart';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass'
import { faFileMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons/faFileMagnifyingGlass'
import { faClipboardListCheck } from '@fortawesome/pro-regular-svg-icons/faClipboardListCheck'
import { faCalendarCheck } from '@fortawesome/pro-regular-svg-icons/faCalendarCheck'

import { FixedFooter as FixedMobileFooter } from 'us-react-components/dist/FixedFooter/FixedFooter';
import { getUrlFromPath, Routes } from '../../../Routes';
import { useDependencies } from '../../../dependencies';

const FixedFooter = (): JSX.Element => {
  const { t } = useTranslation();
  const {
    stores,
    services: { tracker },
  } = useDependencies();
  const { user } = stores.user;
  const isSitter = user!.sitter;
  const location = useLocation();

  const isNux = (): boolean => location.pathname.startsWith('/sitter/registration') || location.pathname.startsWith('/family-reg');;

  const footerLinks = [
    {
      iconName: faHomeHeart,
      link: getUrlFromPath(Routes.homepage),
      trackingTag: 'footer_home',
      label: t('components.fixedFooter.home')
    },
    {
      iconName: faMagnifyingGlass,
      link: getUrlFromPath(Routes.parent.sitters),
      trackingTag: 'footer_search',
      label: t('components.fixedFooter.search')
    },
    {
      iconName: faFileMagnifyingGlass,
      link: getUrlFromPath(Routes.savedSearches),
      trackingTag: 'footer_saved_search',
      label: t('components.fixedFooter.savedSearch'),
      classes: 'w-1/4'
    },
    {
      iconName: faClipboardListCheck,
      link: getUrlFromPath(Routes.parent.posts),
      trackingTag: 'footer_posts',
      label: t('components.fixedFooter.posts')
    },
    {
      iconName: faCalendarCheck,
      link: getUrlFromPath(Routes.bookings.root),
      trackingTag: 'footer_bookings',
      label: t('components.fixedFooter.bookings')
    }
  ];

  const trackEvent = async (event: string, params?: { elementText: string }): Promise<void> => tracker.track(event, params);

  if (isSitter || isNux()) {
    return <div />;
  }

  return (
    <FixedMobileFooter
      footerLinksArray={footerLinks}
      trackingCallback={trackEvent}
    />
  );
};

export { FixedFooter };
